import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
function toError(error) {
    if (error instanceof Error)
        return error;
    if (typeof error === "string")
        return new Error(error);
    try {
        return new Error(JSON.stringify(error));
    }
    catch {
        return new Error("Unknown render error");
    }
}
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.reset = () => {
            this.setState({ hasError: false, error: undefined });
        };
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error: toError(error) };
    }
    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
    render() {
        if (this.state.hasError && this.state.error) {
            if (this.props.renderFallback) {
                return this.props.renderFallback({
                    error: this.state.error,
                    reset: this.reset,
                });
            }
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (_jsxs("div", { style: {
                    padding: "20px",
                    textAlign: "center",
                    border: "1px solid #ff4d4f",
                    borderRadius: "6px",
                    backgroundColor: "#fff2f0",
                    margin: "20px",
                }, children: [_jsx("h2", { style: { color: "#ff4d4f", marginBottom: "16px" }, children: "\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898" }), _jsx("p", { style: { color: "#666", marginBottom: "16px" }, children: this.state.error.message || "应用程序遇到了一个错误" }), _jsx("button", { type: "button", onClick: this.reset, style: {
                            padding: "8px 16px",
                            backgroundColor: "#1890ff",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }, children: "\u91CD\u8BD5" })] }));
        }
        return this.props.children;
    }
}
export default ErrorBoundary;
